<template>
  <section class="invoice-preview-wrapper">
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col
            md="12"
            class="d-flex justify-content-between align-items-center mb-2"
          >
            <h2 class="mb-0">
              {{ $t("reception.patient-lobby-list") }}
            </h2>
            <b-button-group size="sm">
              <b-button
                :variant="viewMode === 'cards' ? 'primary' : 'outline-primary'"
                @click="viewMode = 'cards'"
              >
                <feather-icon icon="GridIcon" size="16" class="mr-50" />
                {{ $t("common.card_view") }}
              </b-button>
              <b-button
                :variant="viewMode === 'list' ? 'primary' : 'outline-primary'"
                @click="viewMode = 'list'"
              >
                <feather-icon icon="ListIcon" size="16" class="mr-50" />
                {{ $t("common.list_view") }}
              </b-button>
            </b-button-group>
          </b-col>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col md="6" cols="12">
            <!-- <h4>Patient Name</h4> -->
            <b-form-group
              :label="$t('reception.patient-name')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="patientName"
                :placeholder="$t('reception.patient-name')"
                @keydown.enter="getPatientCards()"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <h4></h4> -->
            <b-button
              class="mt-50"
              variant="primary"
              @click="getPatientCards()"
            >
              {{ $t("common.search") }}
              <b-icon-search class="ml-1" />
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <!-- List View -->
            <b-table
              v-if="viewMode === 'list' && !loading"
              :items="patientCardsData"
              responsive
              :fields="tableColumns"
              primary-key="id"
              class="position-relative"
              show-empty
              empty-text="No matching patients found"
            >
              <template #cell(patient.name)="data">
                <span class="text-nowrap text-dark">{{
                  data.item.patient.name
                }}</span>
              </template>
              <template #cell(patient.created_at)="data">
                <span class="text-nowrap text-dark">{{
                  data.item.patient.created_at
                }}</span>
              </template>
              <template #cell(patient_room)="data">
                <ul class="list-unstyled mb-0">
                  <li v-for="room in data.item.patient_room" :key="room.id">
                    <b-badge
                      variant="light"
                      class="text-dark"
                      style="font-size: 15px; margin: 3px"
                    >
                      {{ room.room ? room.room.name : '' }}
                    </b-badge>
                  </li>
                </ul>
              </template>
              <template #cell(doctors)="data">
                <ul class="list-unstyled mb-0">
                  <li v-for="doctor in data.item.doctors" :key="doctor.id">
                    <b-badge
                      variant="light"
                      class="text-dark"
                      style="font-size: 15px; margin: 3px"
                    >
                      {{ doctor.name }}
                    </b-badge>
                  </li>
                </ul>
              </template>
              <template #cell(stays)="data">
                <div class="stays-container">
                  <div
                    v-for="stay in data.item.stays"
                    :key="stay.id"
                    class="stay-item mb-2 p-2 border-left border-primary"
                  >
                    <div class="d-flex align-items-center mb-1">
                      <small class="mr-2">Date:</small>
                      <span class="font-weight-bold text-nowrap">{{
                        stay.stay_date_time
                      }}</span>
                    </div>

                    <div v-if="stay.doctors_prices.items.length">
                      <small class=""
                        >Doctor{{
                          stay.doctors_prices.items.length > 1 ? "s" : ""
                        }}:</small
                      >
                      <ul class="pl-3 mb-0 mt-1">
                        <li
                          v-for="doctor in stay.doctors_prices.items"
                          :key="doctor.id"
                          class="doctor-item"
                        >
                          {{ doctor.doctor.name }}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div v-if="!data.item.stays.length" class="text-muted">
                    {{ $t("reception.no-bed-rest") }}
                  </div>
                </div>
              </template>
              <template #cell(surgeries)="data">
                <ul class="list-unstyled mb-0">
                  <li v-for="surgery in data.item.surgeries" :key="surgery.id">
                    <b-badge
                      variant="light"
                      class="text-dark"
                      style="font-size: 15px; margin: 3px"
                    >
                      {{ surgery.surgery.title }}
                    </b-badge>
                  </li>
                </ul>
              </template>
              <template #cell(actions)="data">
                <div class="text-nowrap d-flex">
                  <b-button
                    v-if="$store.state.app.permissions.includes('get-patient')"
                    size="sm"
                    pill
                    variant="outline-secondary"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'Reception-patient-preview',
                        params: { id: data.item.patient.id },
                      })
                    "
                  >
                    {{ $t("common.preview") }}
                  </b-button>
                  <!-- <b-button
                    v-if="$store.state.app.permissions.includes('get-invoice')"
                    size="sm"
                    pill
                    variant="outline-secondary"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'invoices',
                        params: { patientId: data.item.patient.id },
                        query: {
                          patientCardId: data.item.id,
                        },
                      })
                    "
                  >
                    {{ $t("hospital.preview-invoices") }}
                  </b-button> -->
                  <b-button
                    v-if="$store.state.app.permissions.includes('get-invoice')"
                    size="sm"
                    pill
                    variant="outline-secondary"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'out-clinic-invoices',
                        params: {
                          id: data.item.id,
                          name: data.item.patient.name,
                        },
                      })
                    "
                  >
                    {{ $t("reception.out-clinic-invoices") }}
                  </b-button>
                  <b-button
                    size="sm"
                    pill
                    variant="outline-primary"
                    class="mb-75"
                    @click="
                      $router.push({
                        name: 'patient-card-timeline',
                        params: { id: data.item.patient.id },
                      })
                    "
                    >{{ $t("reception.preview-timeline") }}</b-button
                  >
                </div>
              </template>
              <template #cell(phone)="data">
                <span v-if="data.item.patient">{{
                  formatPhoneNumber(data.item.patient.phone)
                }}</span>
              </template>
            </b-table>

            <!-- Card View -->
            <div v-else-if="viewMode === 'cards' && !loading">
              <b-row>
                <b-col
                  v-for="item in patientCardsData"
                  :key="item.id"
                  cols="12"
                  md="6"
                  lg="4"
                  class="mb-3"
                >
                  <b-card no-body class="patient-card h-100">
                    <!-- Card Header -->
                    <div class="card-header-custom">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <h5 class="patient-name mb-0">
                          {{ item.patient.name }}
                        </h5>
                        <b-badge
                          :variant="item.is_active ? 'success' : 'secondary'"
                          pill
                          class="card-type-badge"
                        >
                          {{ item.type }}
                        </b-badge>
                      </div>
                    </div>

                    <!-- Card Body -->
                    <b-card-body class="card-body-custom">
                      <!-- Patient Info -->
                      <div class="patient-info-section mb-1">
                        <div class="info-item">
                          <div class="d-flex align-items-center">
                            <feather-icon
                              icon="PhoneIcon"
                              size="16"
                              class="info-icon mr-1"
                            />
                            <span class="info-text">{{
                              item.patient.phone
                                ? formatPhoneNumber(item.patient.phone)
                                : "N/A"
                            }}</span>
                          </div>
                        </div>
                        <div class="info-item">
                          <div class="d-flex align-items-center">
                            <feather-icon
                              icon="CalendarIcon"
                              size="16"
                              class="info-icon mr-1"
                            />
                            <span class="info-text">{{
                              item.patient.birth_date || "N/A"
                            }}</span>
                          </div>
                        </div>
                      </div>

                      <!-- Rooms -->
                      <div
                        v-if="item.patient_room && item.patient_room.length"
                        class="info-section mb-1"
                      >
                        <div class="section-header">
                          <feather-icon
                            icon="MapPinIcon"
                            size="16"
                            class="section-icon mr-1"
                          />
                          <span class="section-label">{{
                            $t("common.room")
                          }}</span>
                        </div>
                        <div class="badges-container">
                          <b-badge
                            v-for="room in item.patient_room"
                            :key="room.id"
                            variant="light-primary"
                            class="custom-badge"
                          >
                            {{ room.room ? room.room.name : '' }}
                          </b-badge>
                        </div>
                      </div>

                      <!-- Doctors -->
                      <div
                        v-if="item.doctors && item.doctors.length"
                        class="info-section mb-1"
                      >
                        <div class="section-header">
                          <feather-icon
                            icon="UserIcon"
                            size="16"
                            class="section-icon mr-1"
                          />
                          <span class="section-label">{{
                            $t("reception.doctor-name")
                          }}</span>
                        </div>
                        <div class="badges-container">
                          <b-badge
                            v-for="doctor in item.doctors"
                            :key="doctor.id"
                            variant="light-info"
                            class="custom-badge"
                          >
                            {{ doctor.name }}
                          </b-badge>
                        </div>
                      </div>

                      <!-- Surgeries -->
                      <div
                        v-if="item.surgeries && item.surgeries.length"
                        class="info-section mb-1"
                      >
                        <div class="section-header">
                          <feather-icon
                            icon="ActivityIcon"
                            size="16"
                            class="section-icon mr-1"
                          />
                          <span class="section-label">{{
                            $t("reception.surgeries")
                          }}</span>
                        </div>
                        <div class="badges-container">
                          <b-badge
                            v-for="surgery in item.surgeries"
                            :key="surgery.id"
                            variant="light-warning"
                            class="custom-badge"
                          >
                            {{ surgery.surgery.title }}
                          </b-badge>
                        </div>
                      </div>

                      <!-- Stays (Bed Rest) -->
                      <div
                        v-if="item.stays && item.stays.length"
                        class="info-section mb-1"
                      >
                        <div class="section-header">
                          <feather-icon
                            icon="BedIcon"
                            size="16"
                            class="section-icon mr-1"
                          />
                          <span class="section-label">{{
                            $t("reception.bed-rest")
                          }}</span>
                        </div>
                        <div class="stays-container">
                          <div
                            v-for="stay in item.stays"
                            :key="stay.id"
                            class="stay-card-item"
                          >
                            <div class="stay-date">
                              {{ stay.stay_date_time }}
                            </div>
                            <div
                              v-if="stay.doctors_prices.items.length"
                              class="stay-doctors"
                            >
                              <div
                                v-for="doctor in stay.doctors_prices.items"
                                :key="doctor.id"
                                class="stay-doctor-item"
                              >
                                {{ doctor.doctor.name }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="info-section mb-1">
                        <span class="empty-state-text">{{
                          $t("reception.no-bed-rest")
                        }}</span>
                      </div>
                    </b-card-body>

                    <!-- Card Footer with Actions -->
                    <div class="card-footer-custom">
                      <b-button
                        v-if="
                          $store.state.app.permissions.includes('get-patient')
                        "
                        size="sm"
                        variant="outline-primary"
                        class="action-btn"
                        @click="
                          $router.push({
                            name: 'Reception-patient-preview',
                            params: { id: item.patient.id },
                          })
                        "
                      >
                        <feather-icon icon="EyeIcon" size="14" class="mr-1" />
                        {{ $t("common.preview") }}
                      </b-button>
                      <b-button
                        v-if="
                          $store.state.app.permissions.includes('get-invoice')
                        "
                        size="sm"
                        variant="outline-secondary"
                        class="action-btn"
                        @click="
                          $router.push({
                            name: 'out-clinic-invoices',
                            params: {
                              id: item.id,
                              name: item.patient.name,
                            },
                          })
                        "
                      >
                        <feather-icon
                          icon="FileTextIcon"
                          size="14"
                          class="mr-1"
                        />
                        {{ $t("reception.out-clinic-invoices") }}
                      </b-button>
                      <b-button
                        size="sm"
                        variant="outline-info"
                        class="action-btn"
                        @click="
                          $router.push({
                            name: 'patient-card-timeline',
                            params: { id: item.patient.id },
                          })
                        "
                      >
                        <feather-icon icon="ClockIcon" size="14" class="mr-1" />
                        {{ $t("reception.preview-timeline") }}
                      </b-button>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </div>

            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
          </b-col>
        </b-row>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="getPatientCards()"
          >
            <b-pagination
              v-model="page"
              :total-rows="dataCount"
              :per-page="take"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTable,
  BTableLite,
  BCardText,
  BButton,
  BButtonGroup,
  BAlert,
  BLink,
  BFormInput,
  BMedia,
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BIconSearch,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import PatientSearch from "@/components/patientSearch.vue";
import formatPhoneNumber from "@/utils/formatPhoneNumber";

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BButtonGroup,
    BAlert,
    BLink,
    vSelect,
    BFormInput,
    BMedia,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BIconSearch,
    PatientSearch,
  },
  data() {
    return {
      viewMode: localStorage.getItem("receptionLobbyView") || "cards",
      tableColumns: [
        { key: "patient.name", label: this.$t("common.name"), sortable: true },
        {
          key: "patient.created_at",
          label: this.$t("reception.date-in"),
          sortable: true,
        },
        {
          key: "surgeries",
          label: this.$t("reception.surgeries"),
          sortable: true,
        },
        {
          key: "doctors",
          label: this.$t("reception.doctor-name"),
          sortable: true,
        },
        {
          key: "stays",
          label: this.$t("reception.bed-rest"),
          sortable: true,
        },
        {
          key: "patient_room",
          label: this.$t("common.room"),
          sortable: true,
        },
        {
          key: "type",
          label: this.$t("reception.card-type"),
          sortable: true,
        },

        {
          key: "patient.birth_date",
          label: this.$t("reception.birth-date"),
          sortable: true,
        },
        {
          key: "phone",
          label: this.$t("reception.phone"),
          sortable: true,
          class: "text-nowrap",
        },

        { key: "Actions", label: this.$t("common.actions") },
      ],
      patientCardsData: [],

      page: 1,
      totalRows: "",
      todayDate: "",
      take: 10,
      loading: false,
      selected: "",
      option: [],
      patientName: "",
      dataCount: 0,
    };
  },
  watch: {
    viewMode(val) {
      localStorage.setItem("receptionLobbyView", val);
    },
  },

  mounted() {
    this.getPatientCards();
  },
  methods: {
    getNestedProperty(obj, path, defaultValue = "N/A") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      // if (typeof result === "string" && result.startsWith("\\")) {
      //   return defaultValue;
      // }
      // console.log("result", result);
      return result;
    },
    // this is trmporary
    formatPhoneNumber,
    async getPatientCards() {
      this.loading = true;
      let url = `/patientCard?include[]=stays&include[]=doctors&include[]=patientRoom&include[]=surgeries&page=${this.page}&take=${this.take}&sort=-id&filter[is_active]=1`;

      if (this.patientName) {
        url += `&filter[patient.name]=${this.patientName}`;
      }

      await this.getList(url);
      for (const item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.dataCount = this.all_data.total;
      this.patientCardsData = this.all_data.data;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

#modal-add___BV_modal_content_ {
  width: 100% !important;
}

#modal-add {
  margin-left: -8% !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style scoped>
.stay-item {
  border-left-width: 3px !important;
  background-color: rgba(0, 123, 255, 0.05);
  border-radius: 4px;
}

.doctor-item {
  font-size: 14px;
  margin-bottom: 2px;
}

/* For the last doctor item to remove extra bottom margin */
.doctor-item:last-child {
  margin-bottom: 0;
}

/* Card View Styles */
.patient-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  cursor: pointer;
}

.patient-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1), 0 4px 10px rgba(0, 0, 0, 0.08);
  border-color: #d1d5db;
}

/* Card Header */
.card-header-custom {
  padding: 0.625rem 0.875rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 1px solid #e9ecef;
}

.patient-name {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.2;
  margin: 0;
}

.card-type-badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  letter-spacing: 0.025em;
}

/* Card Body */
.card-body-custom {
  padding: 0.75rem 0.875rem;
}

.patient-info-section {
  background-color: #f9fafb;
  padding: 0.5rem 0.625rem;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.info-item {
  display: flex;
  align-items: center;
}

.info-item:not(:last-child) {
  margin-bottom: 0.25rem;
}

.info-icon {
  color: #4b5563;
  flex-shrink: 0;
}

.info-text {
  font-size: 0.9375rem;
  color: #374151;
  font-weight: 500;
  line-height: 1.3;
}

/* Info Sections */
.info-section {
  margin-bottom: 0.5rem;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.375rem;
}

.section-icon {
  color: #4b5563;
  flex-shrink: 0;
}

.section-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.badges-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.custom-badge {
  font-size: 0.8125rem;
  font-weight: 500;
  padding: 0.1875rem 0.5rem;
  border-radius: 4px;
  color: #1f2937;
  border: 1px solid transparent;
}

/* Stays Section */
.stays-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.stay-card-item {
  background-color: #eff6ff;
  border-left: 3px solid #3b82f6;
  border-radius: 4px;
  padding: 0.375rem 0.5rem;
  transition: all 0.2s ease;
}

.stay-card-item:hover {
  background-color: #dbeafe;
  border-left-color: #2563eb;
}

.stay-date {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 0.25rem;
}

.stay-doctors {
  margin-top: 0.25rem;
}

.stay-doctor-item {
  font-size: 0.8125rem;
  color: #374151;
  font-weight: 500;
  padding: 0.0625rem 0;
  line-height: 1.3;
}

.stay-doctor-item:before {
  content: "• ";
  color: #3b82f6;
  font-weight: bold;
  margin-right: 0.25rem;
}

.empty-state-text {
  font-size: 0.875rem;
  color: #9ca3af;
  font-style: italic;
}

/* Card Footer */
.card-footer-custom {
  padding: 0.625rem 0.875rem;
  background-color: #f9fafb;
  border-top: 1px solid #e5e7eb;
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.action-btn {
  font-size: 0.8125rem;
  font-weight: 500;
  padding: 0.3125rem 0.625rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  border-width: 1.5px;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.action-btn .feather-icon {
  vertical-align: middle;
}
</style>
